import { clsx } from "clsx";
import { JSX } from "react";
import { ProgressSpinner } from "../progressSpinner/ProgressSpinner";
import {
  buttonBase,
  buttonSizes,
  buttonVariants,
  content,
  spinnerOverlay
} from "./Button.css";

export interface ButtonPropsCustom extends React.PropsWithChildren {
  /**
   * The size of the button
   */
  size?: keyof typeof buttonSizes;
  /**
   * The variant of the button
   */
  variant?: keyof typeof buttonVariants;
  /**
   * Whether the button is in a loading state
   */
  isLoading?: boolean;
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, ButtonPropsCustom {}

export function Button({
  variant = "primary",
  size = "md",
  children,
  className,
  isLoading = false,
  disabled,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      className={clsx(
        buttonVariants[variant],
        buttonSizes[size],
        buttonBase,
        className
      )}
      disabled={disabled}
      {...props}
      aria-busy={isLoading}
    >
      <span className={content} data-hidden={isLoading}>
        {children}
      </span>

      {isLoading && (
        <span className={spinnerOverlay}>
          <ProgressSpinner />
        </span>
      )}
    </button>
  );
}
